// App Base URL
export const APP_BASE = process.env.REACT_APP_APP_BASE;

// API Base URL
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Media Base URL
export const MEDIA_BASE_URL = process.env.REACT_APP_MEDIA_BASE_URL;

// SOCKET Settings
export const SOCKET_ENABLED = process.env.REACT_APP_SOCKET_ENABLED;
export const SOCKET_API_URL = process.env.REACT_APP_SOCKET_API_URL;

// CDN Settings
export const CDN_ENABLED = process.env.REACT_APP_CDN_ENABLED;
export const CDN_BASE_URL = process.env.REACT_APP_CDN_BASE_URL;

// App Name
export const APP_NAME = process.env.REACT_APP_APP_NAME;

// App Version
export const APP_VERSION = process.env.REACT_APP_APP_VERSION;

// Image Placeholders
export const PLACEHOLDERS = {
  thumbnail: "/media/avatars/blank.png",
};

// Desktop Notification Codes
export const DESKTOP_NOTIFICATION_CODES = ["NEW.MESSAGE"];

export const HIDDEN_TOAST_ERROR_CODES = [401];
